import React from "react";
import * as S from "./styles";

export default function Modal({ title, size, children, ...props }) {
  return (
    <S.ModalMaterial {...props}>
      <S.ModalContent size={size}>
        <S.HeadModal position="relative" prop={size}>
          <S.ModalTitleBar>
            <S.TitleModal variant="h6">{title}</S.TitleModal>

            <S.IconsButton
              aria-label="display more actions"
              edge="end"
              color="inherit"
              onClick={() => props.onClose()}
            >
              <S.CloseBtn />
            </S.IconsButton>
          </S.ModalTitleBar>
        </S.HeadModal>

        {children}
        <div />
      </S.ModalContent>
    </S.ModalMaterial>
  );
}
